import IRouteInfo from '../interfaces/IRouteInfo';
import UserRoles from '../data/UserRoles';
import { Route, Redirect } from 'react-router-dom';
import React from 'react';
import { UserRouteInfo, UserRouteKeys } from '../routes/UserRoutes';
import IUser from '../interfaces/IUser';
import { AppRouteInfo, AppRouteKeys } from '../routes/AppRoutes';

//returns an array of Routes base on if the user is logged in and their role.
export const CreateRoutes = (routeInfoArray:IRouteInfo[], keyPrefix:string, loggedIn:boolean, currentUser:IUser | undefined) => ( 
    routeInfoArray.filter((route) => route.autoInstantiate).map((route, i) => {
        if(route.roles.filter(role => role === UserRoles.unregistered).length) {
            return <Route key={`${keyPrefix}-${i}`} path={route.path} render={() => <route.component {...route} />} exact />
        } else {
            if(loggedIn) {
                if(route.roles.filter(role => role === currentUser?.role || role === UserRoles.allRegistered).length) {
                    return <Route key={`${keyPrefix}-${i}`} path={route.path} render={() => <route.component {...route} />} exact />
                } else {
                return <Route key={`${keyPrefix}-${i}`} path={route.path} render={() => <Redirect to={UserRouteInfo[UserRouteKeys.Unauthorized].path} />} />
                }
            } else {
                return <Route key={`${keyPrefix}-${i}`} path={route.path} render={() => <Redirect to={AppRouteInfo[AppRouteKeys.Home].path} />} />
            }
        }  
    })
);
